/*
  Source of truth: IncidentForm/Assets/questions.json
  This file is auto-generated by sync-questions.js — do not edit directly.
  To add or modify questions:
    1. Edit  IncidentForm/Assets/questions.json
    2. Run   node sync-questions.js  (from the IncidentForm folder)
    3. Rebuild the frontend
*/
import data from "./questions.json";
export const incidentTypes = data.incidentTypes;
